import { api, IMPORT_GAME_MESSAGE, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { mapToFormData, PropertyType } from '../../../common';

export const importGames = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/bulk-create', mapToFormData(mapEntityToApi(data)), setConfig(data)).then((res) => {
		return {
			message: IMPORT_GAME_MESSAGE,
			nonImportedGames: res.data.notImportedGames,
			importedGames: res.data.importedGames,
			data: res.data,
		};
	});
